// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rRLFX","newExpiryDate":"styles_newExpiryDate__35Tl1","footer":"styles_footer__3hSya"};